import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import {
    LaboratoryProcessConfigurationCreateRequest, LaboratoryProcessConfigurationPatchInBatchRequest,
    LaboratoryProcessConfigurationResponse
} from '@/modules/configurationModule/detail/local-laboratory-module/laboratory-process/services/laboratory-process/laboratory-process.dto'

class LaboratoryProcessService {
    async create(laboratoryId: number, request: LaboratoryProcessConfigurationCreateRequest): Promise<LaboratoryProcessConfigurationResponse> {
        const response = await axios.post<LaboratoryProcessConfigurationResponse>(`/configuration/laboratories/${laboratoryId}/laboratoryProcessConfigurations/`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel, params: CommonParams, laboratoryId: number): Promise<IResponseAgGrid<LaboratoryProcessConfigurationResponse>> {
        const response = await axios.put<IResponseAgGrid<LaboratoryProcessConfigurationResponse>>(`/configuration/laboratories/${laboratoryId}/laboratoryProcessConfigurations/`, { ...filterModel }, { params })
        return response.data
    }

    async get(laboratoryProcessConfigurationId: number, laboratoryId: number): Promise<LaboratoryProcessConfigurationResponse> {
        const response = await axios.get<LaboratoryProcessConfigurationResponse>(`/configuration/laboratories/${laboratoryId}/laboratoryProcessConfigurations/${laboratoryProcessConfigurationId}`)
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/laboratoryProcessConfigurations/batch`, { data: request })
        return response.data
    }

    async patch(laboratoryId: number, request: LaboratoryProcessConfigurationPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/laboratoryProcessConfigurations/batch`, request)
        return response.data
    }
}

export const laboratoryProcessService = new LaboratoryProcessService()
